@let editingSegmentId = store.editingSegmentIdSg();

@if (editingSegmentId) {
  <atn-ds-centered-overlay type="full-width">
    <div class="atn-mosaic-page-segment-dialog">
      <atn-ds-widget title="Edit Segment">
        <div actions>
          <!-- TODO: Run query button should be added -->
          <i
            class="atn-icon atn-close atn-red"
            (click)="cancelBtnClickHandler()"
          ></i>
        </div>

        <div class="atn-mosaic-page-segment-dialog__body">
          <atn-ds-integrated-horizontal-tabs>
            <ng-template
              atnDsTab
              name="General"
            >
              <atn-segment-dialog-general-tab />
            </ng-template>
            <ng-template
              atnDsTab
              name="Query"
            >
              <atn-segment-dialog-query-tab />
            </ng-template>
          </atn-ds-integrated-horizontal-tabs>
        </div>

        <div
          footer
          class="atn-mosaic-page-segment-dialog__footer"
        >
          <atn-ds-button
            type="danger"
            (click)="deleteSegmentBtnClickHandler()"
            >Delete</atn-ds-button
          >
          <div class="atn-mosaic-page-segment-dialog__footer-right-content">
            <atn-ds-button
              type="transparent"
              (click)="cancelBtnClickHandler()"
              >Cancel</atn-ds-button
            >
            <atn-ds-button (click)="saveBtnClickHandler()">
              Save
            </atn-ds-button>
          </div>
        </div>
      </atn-ds-widget>
    </div>
  </atn-ds-centered-overlay>
}
